import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77808a92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-contain" }
const _hoisted_2 = {
  name: "open_card",
  class: "btn-open-card"
}
const _hoisted_3 = { class: "button-contain" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/play" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "button-image",
              src: `${require('@/assets/images/home/btn-start.png')}`
            }, null, 8, _hoisted_4)
          ])
        ]),
        _: 1
      })
    ])
  ]))
}